import { render } from "./PreviewLicencasOrcamento.vue?vue&type=template&id=71805ee0"
import script from "./PreviewLicencasOrcamento.vue?vue&type=script&lang=ts"
export * from "./PreviewLicencasOrcamento.vue?vue&type=script&lang=ts"
script.render = render

export default script